<template>
	<div
		class="side-bar-drawer"
		:class="[
			drawerDir,
			{
				'is-drawer-open': isSideBarDrawerOpen,
				'transactional-emails': isTransactionalEmails,
			},
			isCodeBlock ? 'code-block' : 'height-100',
		]"
	>
		<SideBarDrawerKnob :drawerDir="drawerDir" />
		<SideBarDrawerContent
			class="table-preview"
			:isCodeBlock="isCodeBlock"
			:isTransactionalEmails="isTransactionalEmails"
			v-if="isSideBarDrawerOpen"
		/>
	</div>
</template>
<script>
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

import SideBarDrawerContent from './SideBarDrawerContent.vue';
import SideBarDrawerKnob from './SideBarDrawerKnob.vue';
import { SideBarDrawerDirection, isValidSideBarDrawerDirection } from './helpers';
import { editNode } from '@/store/modules/selectedNode/getters';
import { isSideBarDrawerOpen } from '@/store/modules/sideBarDrawer/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'SideBarDrawer',
	components: {
		SideBarDrawerContent,
		SideBarDrawerKnob,
	},
	props: {
		drawerDir: { type: String, default: SideBarDrawerDirection.Left, validator: isValidSideBarDrawerDirection },
	},
	computed: {
		...mapGettersShorthand({ editNode, isSideBarDrawerOpen }),
		paramsMap() {
			return this.editNode?.params_map;
		},
		isTransactionalEmails() {
			// TODO, better check if this is the send_email action, like the `onCreateCodeHelperClicked` method does
			return !!(this.editNode?.service_slug === ServiceSlugs.TransactionalEmails);
		},
		isCodeBlock() {
			return !!(this.editNode?.service_slug === ServiceSlugs.CodeBlock && this.paramsMap?.code_block);
		},
	},
};
</script>

<style scoped lang="scss">
.side-bar-drawer {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 0vw;
	padding: 10% 0;
	transform: translate(0, 0);
	transition: 0.5s;

	.table-preview {
		padding: 10px;
		border: 1px solid #e7eaf3;
		background-color: var(--primary-bg-color);
		visibility: hidden;
		display: none;
	}

	&.right {
		&:not(.is-drawer-open) {
			transform: translate(-100%, 0);
		}
		.table-preview {
			border-top-right-radius: 11px;
			border-bottom-right-radius: 11px;
		}
	}
	&.left {
		&.is-drawer-open {
			transform: translate(-100%, 0);
		}
		.table-preview {
			border-top-left-radius: 11px;
			border-bottom-left-radius: 11px;
		}
	}

	&.code-block {
		height: 90vh;
		margin-top: 5rem;
		@media (max-width: 1515px) {
			height: 88vh;
		}
	}

	&.is-drawer-open {
		width: 60vw;
		transition: 0.5s;
		.table-preview {
			visibility: visible;
			display: block;
			box-shadow: var(--secondary-box-shadow);
		}
		&.right {
			width: 50vw;
		}
		&.code-block {
			width: 35vw;
			@media (max-width: 1515px) {
				width: 40vw;
			}
		}
		&.transactional-emails {
			width: 40vw;
		}
	}
}
</style>
